import React from 'react';
import { formatDefaultDate } from '../../../utils';
import { Paragraphe } from '../../Utils/UI/PragrapheComponent';

export const PodComponent = ({ Expedition }) => {
    const returnDate = () => {
        if (Expedition.pickup_date) {
            return Expedition.pod?.[0]?.["date"] ? formatDefaultDate(Expedition.pod?.[0]?.["date"]) : ""
        }

    }

    return (
        <div className="h-full pb-5 bg-white rounded-md">
            <div className="px-3 ">

                <div className="text-center  flex items-center justify-center text-base font-semibold h-[40px] py-6">
                    PREUVE DE LIVRAISON
                </div>
                <hr className="mt-0" />
                <div className="mt-6 text-base font-normal uppercase">
                    <Paragraphe label={`Signataire`} value={`${Expedition.pod?.[0]?.["signature"] || ""}`} />
                    <Paragraphe label={'Date de livraison'} value={returnDate()} />
                    <Paragraphe label={'Heure de livraison'} value={Expedition.pod?.[0]?.["heurs"] || ""} />
                </div>
            </div>
        </div>
    );
}
